import axios from 'axios';
import { constants } from '../constants/constants';
import { endPoints } from '../constants/endPoints';
// import ParameterVerifier from '../helper/parameterVerifier';

/**
 * 
 * @Author  : Anup Saha
 * @Date:   : 2020-03-13
 */

function post(url, params) {
    return new Promise((resolve, reject) => {
        let HOST = constants.endPoint;
        url = HOST + url;
        let imputParams = new URLSearchParams();
        imputParams.append('input_param', JSON.stringify(params));
        axios.post(url, imputParams,
            {
                headers: {
                    'dataType': 'jsonp',
                    'contentType': 'application/json; charset=utf-8',
                }
            })
            .then((resp) => {
                if (resp.data.status == constants.STATUS_FAILURE) {
                    // window.location.replace("/");
                    resolve(resp.data);
                } else {
                    resolve(resp.data);
                }
            })
            .catch(err => {
                reject(err);
            });
    });
}

function get(url, params) {
    // url = ParameterVerifier.getStringParam(url);
    if (url != '') {
        return new Promise((resolve, reject) => {
            let HOST = constants.endPoint;
            url = HOST + url;
            axios.get(url, {
                headers: {
                    'dataType': 'jsonp',
                    'contentType': 'application/json; charset=utf-8',
                },
                params: { input_param: params }
            }).then((resp) => {
                resolve(resp.data);

            }).catch(err => {
                reject(err);
            });
        });
    }
}

function getFullResponseWithoutToken(url, params) {
      if (url!= null && url != '') {
        return new Promise((resolve, reject) => {
            let HOST = constants.endPoint;
            url = HOST + url;
            axios.get(url, {
                headers: {
                    'dataType': 'jsonp',
                    'contentType': 'application/json; charset=utf-8',
                },
                params: { input_param: params },
            }).then((resp) => {
                resolve(resp.data);
            }).catch(err => {
                reject(err);
            });
        });
    }
}
function postWithoutToken(url, params) {
    return new Promise((resolve, reject) => {
        let HOST = constants.endPoint;
        if (url != null && url != '') {
            url = HOST + url;
            let imputParams = new URLSearchParams();
            imputParams.append('input_param', JSON.stringify(params));
            axios.post(url, imputParams,
                {
                    headers: {
                        'dataType': 'jsonp',
                        'contentType': 'application/json; charset=utf-8'
                    }
                })
                .then((resp) => {
                    if (resp.data.status == constants.STATUS_FAILURE) {
                        resolve(resp.data);
                    } else {
                        resolve(resp.data);
                    }
                })
                .catch(err => {
                    reject(err);
                });
        }
    });
}
export { get, post ,getFullResponseWithoutToken,postWithoutToken};